<template>
  <div v-loading="loading">
    <div style="margin-bottom: 20px">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item> 处方管理 </el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <el-card shadow="hover" style="margin-bottom: 12px; padding: 10px">
      <el-form :inline="true" :model="formInline" @submit.native.prevent>
        <el-form-item label="门店仓库">
          <customer-store-select
            :defaultFirst="true"
            style="width: 180px"
            v-model="storeGuid"
            placeholder="门店"
          />
        </el-form-item>
        <el-form-item label="经营月份">
          <time-range
            :cache="false"
            timeType="month"
            @change="handleTimeChange"
          />
        </el-form-item>
      </el-form>
    </el-card>
    <el-card shadow="hover">
      <div v-if="storeInfo">
        <div style="padding: 20px">
          <x-table
            ref="list"
            listApi="biz.warehouse.vet.prescription.info.list"
            paginationLayout="total, sizes, prev, next, jumper"
            actionFixed="right"
            emptyLabel="暂无兽药处方笺信息"
            :fieldList="fieldList"
            :actionList="actionList"
            :defaultParams="defaultParams"
            :actionWidth="120"
          >
            <template slot="row-info" slot-scope="scope">
              <warehouse-vet-prescription :vetPrescriptionInfo="scope.row" />
            </template>
          </x-table>
          <div style="margin-top: 20px">
            <span style="color: #919191">
              *
              订单中含有兽用处方药时，会自动创建电子处方笺，并由执业兽医师完成审核和开具
            </span>
          </div>
        </div>
      </div>
      <el-empty v-else-if="!loading" :description="errorMsg" :image-size="100">
        <el-button v-if="errorMsg" @click="getDetail" size="small">
          重新加载
        </el-button>
      </el-empty>
    </el-card>
  </div>
</template>

<script>
import prescriptionDetail from './detail.vue';
import customerStoreSelect from '../../../../components/business/customerStoreSelect.vue';
import warehouseVetPrescription from '../../../../components/business/warehouseVetPrescription.vue';
import timeRange from '../../../../components/timeRange.vue';

export default {
  components: {
    customerStoreSelect,
    warehouseVetPrescription,
    timeRange,
  },
  data() {
    return {
      times: null,
      loading: false,
      errorMsg: null,
      storeGuid: "",
      formInline: {},
      storeInfo: null,
      actionList: [
        {
          label: '详情',
          linkType: 'primary',
          click: (row, tag, refresh) => {
            this.$drawer.openDrawer({
              title: '处方单详情',
              refresh: this.refresh,
              component: prescriptionDetail,
              params: {
                guid: row.guid,
                storeGuid: row.storeGuid
              },
            });
          },
        },
      ],
      fieldList: [
        {
          label: "处方信息",
          minWidth: '280',
          slot: "info",
        },
      ],
    };
  },
  watch: {
    storeGuid() {
      this.commitState({ curStoreGuid: this.storeGuid });
      this.fetchStoreInfo();
    }
  },
  computed: {
    defaultParams() {
      return Object.assign({
        optCancel: "0",
        storeGuid: this.storeGuid
      }, this.times || {})
    }
  },
  methods: {
    handleTimeChange(time) {
      this.times = time;
    },
    fetchStoreInfo() {
      if (this.storeGuid) {
        this.errorMsg = null;
        this.loading = true;
        this.requestApi("biz.customer.store.info.detail", {
          guid: this.storeGuid
        }, {
          cache: 1,
          cacheCallback: (resp) => {
            this.loading = false;
            this.storeInfo = resp.data;
          }
        }).then((resp) => {
          this.loading = false;
          this.storeInfo = resp.data;
        }).catch((err) => {
          this.loading = false;
          this.errorMsg = (err && err.msg) || (err && err.message)
            || "连接服务器失败，请检查网络";
        });
      } else {
        this.loading = false;
        this.errorMsg = null;
        this.storeInfo = null;
      }
    },
  },
  mounted() {
    this.storeGuid = this.readState("curStoreGuid", "");
    this.fetchStoreInfo();
  },
};
</script>